import React, { useState, useEffect } from 'react'
// import "./SearchTeacher.css"
// import DatePicker from 'react-datepicker'
import { withRouter } from 'react-router-dom'
// import { Pagination, Responsive } from "semantic-ui-react"
import Pagination from '../../../Components/Pagination/Pagination'
// import { notify } from 'react-notify-toast'
import CollegePageContainer from '../../Container/CollegePageContainer'
import { connect } from 'react-redux'
import { addRemoveFavouriteTeacher } from '../../../redux/college/college.actions'
import { API } from '../../../API'
import JobListingCard from '../../../Components/JobListingCard/JobListingCard'
import {
  getClassCategories,
  getCurrentPage,
  filterJobCriterias,
} from '../../../Helper'
// import SearchBar from '../../../Components/SearchBar/SearchBar'
import ConfirmButton from '../../../Components/Buttons/ConfirmButton'
import Spinner from '../../../Components/Spinner/Spinner'
// import { createUserObject } from "../Profile/profile.utils"
import { getProgressCollege } from "../../../Helper/CollegeHelper";
import Auth from "../../../Auth/Auth";
import {permIndices} from "../../../Permissions";

const MyApplications = (props) => {
  let [isLoaded, setIsLoaded] = useState(false)
  let [pageNum, setPageNum] = useState(1)
  let [allJobs, setAllJobs] = useState([])
  let [isAbleToEdit,setIsAbleToEdit] = useState(true)
  let [showCurrentJobs, setShowCurrentJobs] = useState([]) // current page of results
  let [searchResults, setSearchResults] = useState([]) // all search results
  let [searchKeyword, setSearchKeyword] = useState('')
  let [searchLocation, setSearchLocation] = useState('')
  let [searchCategory, setSearchCategory] = useState('all')

  const progress_check = getProgressCollege(
    props.user,
    props.institution,
    [],
    props.campuses,
    []
  ).p_c;

  useEffect(() => {
    Auth.authCheck(1 << permIndices.ed_lst)
        .then((res) => {
          setIsAbleToEdit( res.authenticated )
        })
    // todo: retrieve jobs
    API.getListingByInst(props.institution._id)
      .then((res) => {
        let listings = res.data.result
          .filter((listing) => listing.status === 'draft')
          .sort((a, b) => {
            return new Date(b.pub_date) - new Date(a.pub_date)
          })

        listings = listings.map((listing) => {
          const inst = props.institution
          const campus =
            props.campuses.find((campus) => campus._id === listing.location) ||
            {}
          // console.log(listing, inst, campus)
          return {
            ...listing,
            institution_name: inst.institution_name,
            institution_logo: inst.logo,
            location: campus.suburb.trim() + ", " + campus.state,
          }
        })
        setAllJobs(listings)
        setSearchResults(listings)
        handlePage(pageNum, listings)
        setIsLoaded(true)
      })
      .catch((err) => {
        console.log(err)
        setIsLoaded(true)
      })
  }, [])

  // Show 10 users per page ------
  let handlePage = (pageNumber, jobs) => {
    setShowCurrentJobs(getCurrentPage(pageNumber, jobs))
    setPageNum(pageNumber)
  }

  const onPageNumChange = (e) => {
    // console.log(e.target.getAttribute("value"))
    handlePage(e.target.getAttribute('value'), searchResults)
  }

  const search = ({ keyword, category, location }) => {
    let kw = (keyword !== undefined ? keyword : searchKeyword).toLowerCase()
    let cat = (category !== undefined ? category : searchCategory).toLowerCase()
    if (cat === 'all') {
      cat = ''
    }
    let loc = (location !== undefined ? location : searchLocation).toLowerCase()

    if (kw || cat || loc) {
      if (allJobs.length > 0) {
        let filteredJobs = allJobs.filter((job) => {
          let searchFilter = filterJobCriterias(job)
          return (
            searchFilter.keyword.includes(kw) &&
            searchFilter.category.includes(cat) &&
            searchFilter.location.includes(loc)
          )
        })
        handlePage(pageNum, filteredJobs)
        setSearchResults(filteredJobs)
      }
    } else {
      setSearchResults(allJobs)
      handlePage(pageNum, allJobs)
    }
  }

  const onSearchCategory = (e) => {
    let category = e.target.id
    setSearchCategory(category)
    search({ category })
  }

  const onClickTag = (keyword) => {
    setSearchKeyword(keyword)
    search({ keyword })
  }

  const onChangeKeyword = (e) => {
    let keyword = e.target.value
    setSearchKeyword(keyword)
    search({ keyword })
  }

  const onChangeLocation = (e) => {
    let location = e.target.value
    setSearchLocation(location)
    search({ location })
  }

  const tabs = [
    {
      text: 'My Vacancies',
      pathname: '/MyListings',
    },
    {
      text: 'My Drafts',
      pathname: '/MyDrafts',
      active: true,
    },
  ]

  let categories = getClassCategories()
  categories.unshift({ value: 'all', name: 'Show All' })

  let newListingDisabled = !(
    progress_check.logo &&
    progress_check.courses
    // progress_check.website
  )

  // newListingDisabled = true

  const buildConfirmButton = (className) => {
    if(isAbleToEdit) {
    return (

          <>
            <ConfirmButton
                className={className}
                onClick={() => props.history.push('/PostJobDraft')}
                disabled={newListingDisabled}
                title={newListingDisabled ? "Please add your company logo and courses delivered" : ""}
            >
              Create New Vacancy
            </ConfirmButton>
            {newListingDisabled &&
            "You must complete more of your company profile to create a job vacancy."
            }
          </>
    )
    }
    else
    {
      return (
          <>
          </>
      )
    }
  }

  return (
    <CollegePageContainer user={props.user} header='Job Board' tabs={tabs}>
      <div className='search-teacher-container'>
        <div className='search-teacher-main p-0'>
          <h2 className='search-teacher-heading ml-3 mb-3'>
            My Drafts
          </h2>
          {isLoaded &&
            (searchResults.length > 0 ? (
              <div className='d-flex flex-column align-items-end mb-3'>
                {buildConfirmButton('mr-3')}
              </div>
            ) : (
              <div className='align-items-center'>
                <p className='text-center mb-3'>
                  Currently there is no data available.
                </p>
                <div className="d-flex flex-column align-items-center">
                  {buildConfirmButton("mx-0 mb-3")}
                </div>
              </div>
            ))}
          <div className='all-listings-container'>
            {isLoaded ? (
              searchResults.length ? (
                showCurrentJobs.map((job) => {
                  return (
                    <JobListingCard
                      job={job}
                      onClickTag={onClickTag}
                      isPersonel={true}
                      isEditable={isAbleToEdit}
                      isApplied
                    />
                  )
                })
              ) : null
            ) : (
              <Spinner small />
            )}
          </div>

          {searchResults.length ? (
            <Pagination
              itemArray={searchResults}
              pageNum={pageNum}
              onPageNumChange={onPageNumChange}
            />
          ) : null}
        </div>
      </div>
    </CollegePageContainer>
  )
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses,
  }
}

const mapDispatchToProps = {
  addRemoveFavouriteTeacher,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyApplications))
